import "./AddUserToTeam.html";

import "../../Forms/FindAddUser/FindAddUserComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddUserToTeamComponentController from "./AddUserToTeamComponentController";

export default class AddUserToTeamComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddUserToTeamComponentController;
        this.templateUrl = "/App/Components/Team/AddUserToTeam/AddUserToTeam.html";
    }
}

module("mmManagePortal").component("mmAddUserToTeam", new AddUserToTeamComponent());
